import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  height: 50px;
  width: 35px;
`
